import { Box } from "@mui/material";
import React from "react";
import { useSelector } from "react-redux";
import StlapFooter from "../CustomComponents/StlapFooter";
import NachRetrievalFilter from "./NachRetrievalFilter";
import NachRetrievalList from "./NachRetrievalList";

const NachRetrieval = () => {
  //Selectors from redux store
  const showRetrievalList = useSelector(
    (state) => state.nachRetrieval.showRetrievalList
  );
  return (
    <>
      <Box style={{ minHeight: "calc(100vh - 120px)" }}>
        <NachRetrievalFilter />
        {showRetrievalList && <NachRetrievalList />}
      </Box>

      <StlapFooter />
    </>
  );
};

export default NachRetrieval;
